import * as React from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import { useNavigate } from "react-router-dom";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import configData from "../config.json";
import { GetSession, GetToken } from "../components/Session";

const EventLogs = () => {
    const [columns, setColumns] = React.useState(null);
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const types = [
        { id: "-1", name: "All" },
        { id: "0", name: "System" },
        { id: "1", name: "First Weigh" },
        { id: "2", name: "Incomplete Transaction" },
        { id: "3", name: "Complete Transaction" },
        { id: "4", name: "Visiting" },
        { id: "5", name: "Offence" },
        { id: "6", name: "Other" },
        { id: "7", name: "Overload" },
        { id: "8", name: "Other" }
    ]

    let dr = JSON.parse(localStorage.getItem('EventLogDates'));
    if (dr !== null){
        if (dr.start !== null) dr.start = new Date(dr.start);
        if (dr.end !== null) dr.end = new Date(dr.end);
    } else {
        let dt = new Date();
        dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: null};
        localStorage.setItem("EventLogDates", JSON.stringify(dr));
    }

    const rangeChanged = (event) => { 
        ChangeRange(event.target.value, parseInt(user.id), parseInt(eventType.id));
    }

    const ChangeRange = (dr, u, t) => {
        setDateRange(dr); 
        localStorage.setItem("EventLogDates", JSON.stringify(dr));
        var params = {
            FromDate: dr.start === null ? "2000-01-01T00:00:00Z" : dr.start.toISOString(),
            ToDate: dr.end === null ? "2050-01-01T00:00:00Z" : dr.end.toISOString(),
            UserId: u,
            Type: t
        };
        setLookupParams(encodeURI(JSON.stringify(params)));        
    }

    const userChanged = (event) => {
        setUser(event.target.value);
        ChangeRange(dateRange, parseInt(event.target.value.id), parseInt(eventType.id));
    }

    const typeChanged = (event) => {
        setEventType(event.target.value);
        ChangeRange(dateRange, parseInt(user.id), parseInt(event.target.value.id));
    }

    const [dateRange, setDateRange] = React.useState(dr);
    const [users, setUsers] = React.useState([]);
    const [user, setUser] = React.useState({ id: "0", name: "All" });
    const [eventType, setEventType] = React.useState({ id: "", name: "All" });
    const [lookupParams, setLookupParams] = React.useState("");     
    React.useEffect(() => { 
        GetColumnDefs("EventLogs", setColumns); 
        GetPermissions(["ViewPrintEventLog"], setPermissions);
        ChangeRange(dateRange, 0, -1);
        const baseUrl = configData.SERVER_URL + "apiv7/options";
        const init = { method: "GET", accept: "application/json", headers: {"Authorization": "Bearer " + GetToken()} };
        fetch(baseUrl, init).then((response) => response.json()).then((d) => {
            setUsers(CreateList(d.users));
            setUser({ id: "0", name: "All" });
        });
      }, [])

        
  const CreateList = (d) => {
    var x = [{ id: "0", name: "All" }];
    return x.concat(d);
  };

    if (permissions && !permissions.CanView) navigate("/");

    return (
        <div>
            <div style={{ paddingTop: "20px" }}> 
            {permissions && permissions.CanView && <div className="row" style={{padding:"5px 10px"}}>
                    <div className="col-md-3" style={{ marginLeft: "30px" }} >
                    <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged}  />
                    </div>
                    <div className="col-md-2" style={{ paddingTop: "7px"}} >
                        <label className="control-label">Event Type</label>
                        <DropDownList id="Type" data={types} value={eventType} textField="name" dataItemKey="id" onChange={typeChanged} />
                    </div>
                    <div className="col-md-2" style={{ paddingTop: "7px"}} >
                        <label className="control-label">User</label>
                        <DropDownList id="User" data={users} value={user} textField="name" dataItemKey="id" onChange={userChanged}/>
                    </div>
            </div>}
        </div>           
        {columns && permissions && permissions.CanView && <DataGrid dataSource='apiv7/eventlogs' columns={columns} permissions={permissions} keyField ="eventLogId" params={lookupParams}/>}
        </div>       
    );

}

export default EventLogs;